export default "__VITE_ASSET__Cgk$yAEB__"